import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=69cdda2d&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cdda2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69cdda2d')) {
      api.createRecord('69cdda2d', component.options)
    } else {
      api.reload('69cdda2d', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=69cdda2d&scoped=true&", function () {
      api.rerender('69cdda2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IP21DnjwIKQZ/JS/comp/Accordion.vue"
export default component.exports